import { skipToken } from "@reduxjs/toolkit/query";
import { useGetAllProductAvailableTimeQuery, useGetCartByGuestIdQuery, useGetMyOrderByGuestIdQuery } from "../../features/guest/guestApiSlice";
import { getRtkErrorMessage } from "../../utils/getRtkErrorMessage";
import { useGetClientChapelAndRemainingQtyQuery } from "../../features/client/clientApiSlice";
import { useGetPackageItemsQuery, useGetPackageSummaryBaseOnIdQuery } from "../../features/package/packageApiSlice";

interface UseDynamicQueryDataProps {
    clientId?: number | null;
    guestId?: number | null;
    packageID?: number | null;
}

export const useDynamicQueryData = ({ clientId, guestId, packageID, }: UseDynamicQueryDataProps) => {
    
    const { data: availableProductOfClient, isError: isErrorAvailableProductOfClient, error: errorAvailableProductOfClient, isLoading: isLoadingAvailableProductOfClient, refetch: refetchAvailableProductOfClient, isFetching: isFetchingAvailableProductOfClient } = useGetAllProductAvailableTimeQuery(clientId ?? skipToken, {refetchOnMountOrArgChange: true});
    const errorMessageAvailableProductOfClient = getRtkErrorMessage(errorAvailableProductOfClient);

    const { data: chapelNameAndRemainingQty, isError: isErrorChapelNameAndRemainingQty, error: errorChapelNameAndRemainingQty, isLoading: isLoadingChapelNameAndRemainingQty, refetch: refetchChapelNameAndRemainingQty, isFetching: isFetchingChapelNameAndRemainingQty } = useGetClientChapelAndRemainingQtyQuery(clientId ?? skipToken, {refetchOnMountOrArgChange: true});
    const errorMessageChapelNameAndRemainingQty = getRtkErrorMessage(errorChapelNameAndRemainingQty);

    const { data: guestCart, isError: isErrorGuestCart, error: errorGuestCart, isLoading: isLoadingGuestCart, refetch: refetchGuestCart, isFetching: isFetchingGuestCart } = useGetCartByGuestIdQuery(guestId ?? skipToken);
    const errorMessageGuestCart = getRtkErrorMessage(errorGuestCart);

    const { data: myOrders, isError: isErrorMyOrders, error: errorMyOrders, isLoading: isLoadingMyOrders, refetch: refetchMyOrders, isFetching: isFetchingMyOrders } = useGetMyOrderByGuestIdQuery(guestId ?? skipToken);
    const errorMessageMyOrders = getRtkErrorMessage(errorMyOrders);

    const { data: packageSummaryBaseOnIdQuery, isError: isErrorPackageSummaryBaseOnIdQuery, error: errorPackageSummaryBaseOnIdQuery, isLoading: isLoadingPackageSummaryBaseOnIdQuery, refetch: refetchPackageSummaryBaseOnIdQuery, isFetching: isFetchingPackageSummaryBaseOnIdQuery } = useGetPackageSummaryBaseOnIdQuery(clientId ?? skipToken, {refetchOnMountOrArgChange: true})
    const errorMessagePackageSummaryBaseOnIdQuery = getRtkErrorMessage(errorPackageSummaryBaseOnIdQuery);

    const { data: getPackageProducts, isError: isErrorGetPackageProducts, error: errorGetPackageProducts, isLoading: isLoadingGetPackageProducts, refetch: refetchGetPackageProducts, isFetching: isFetchingGetPackageProducts } = useGetPackageItemsQuery(packageID ?? skipToken, {refetchOnMountOrArgChange: true})
    const errorMessageGetPackageProducts= getRtkErrorMessage(errorGetPackageProducts);

    return {
        availableProductOfClient,
        isErrorAvailableProductOfClient,
        errorAvailableProductOfClient,
        isLoadingAvailableProductOfClient,
        refetchAvailableProductOfClient,
        isFetchingAvailableProductOfClient,
        errorMessageAvailableProductOfClient,

        chapelNameAndRemainingQty,
        isErrorChapelNameAndRemainingQty,
        errorChapelNameAndRemainingQty,
        isLoadingChapelNameAndRemainingQty,
        refetchChapelNameAndRemainingQty,
        isFetchingChapelNameAndRemainingQty,
        errorMessageChapelNameAndRemainingQty,

        guestCart,
        isErrorGuestCart,
        errorGuestCart,
        isLoadingGuestCart,
        refetchGuestCart,
        isFetchingGuestCart,
        errorMessageGuestCart,

        myOrders,
        isErrorMyOrders,
        errorMyOrders,
        isLoadingMyOrders,
        refetchMyOrders,
        isFetchingMyOrders,
        errorMessageMyOrders,

        packageSummaryBaseOnIdQuery,
        isErrorPackageSummaryBaseOnIdQuery,
        errorPackageSummaryBaseOnIdQuery,
        isLoadingPackageSummaryBaseOnIdQuery,
        refetchPackageSummaryBaseOnIdQuery,
        isFetchingPackageSummaryBaseOnIdQuery,
        errorMessagePackageSummaryBaseOnIdQuery,

        getPackageProducts,
        isErrorGetPackageProducts,
        errorGetPackageProducts,
        isLoadingGetPackageProducts,
        refetchGetPackageProducts,
        isFetchingGetPackageProducts,
        errorMessageGetPackageProducts,
    }
}